export const BaseUrl = "https://luna-back-y4a4.onrender.com";

export const PostUrlAdditional = `${BaseUrl}/api/additional/`

export default PostUrlAdditional;

